var React = require('react');

function Tasks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1024 1408h640v-128h-640v128zM640 896h1024V768H640v128zm640-512h384V256h-384v128zm512 832v256q0 26-19 45t-45 19H64q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 960V704q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 448V192q0-26 19-45t45-19h1664q26 0 45 19t19 45z"}));
}

Tasks.defaultProps = {"width":"1792","height":"1792","viewBox":"0 0 1792 1792"};

module.exports = Tasks;

Tasks.default = Tasks;
